import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addEventService, type AddEventPayload, type AddEventResponse } from "../services/addEventService";

export function useAddEvent() {
  const queryClient = useQueryClient();
  return useMutation<AddEventResponse, Error, AddEventPayload>({
    mutationFn: addEventService,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["events-by-month"] });// Refetch events
      queryClient.invalidateQueries({ queryKey: ["retail-events-by-month"] });
      queryClient.invalidateQueries({ queryKey: ["wholesale-events-by-month"] });
      queryClient.invalidateQueries({ queryKey: ["ecom-events-by-month"] });
    },
  });
}